import { IProjectSpaceTypeCategory } from 'spw-redux/modules/projects/types';
import { useMemo } from 'react';
import { CUSTOM_SUBCATEGORY } from 'spw-constants';
import { ISpaceBreakDown } from 'spw-redux/modules/program-summary/types';
import { useSelector } from 'react-redux';
import { selectProgramSummaryCardIcons } from 'spw-redux/modules/program-summary/esa/selectors';
import { ProgramSummaryCardType } from 'spw-esa-projects/program-summary/icon-selector-popover';

export const useCustomSubcategory = (
  individualWorkspacesCategory: IProjectSpaceTypeCategory,
  wsBreakdownBySubcategory: Record<string, ISpaceBreakDown[]>
) => {
  const customSubcategory = useMemo(() => {
    return individualWorkspacesCategory.subcategories.find((subcategory) => {
      return (
        subcategory.defaultSpaceTypeCategory.category === CUSTOM_SUBCATEGORY
      );
    });
  }, [individualWorkspacesCategory.subcategories]);

  const hasSpacesNotIncludedInTotalSeats = useMemo(() => {
    return (
      !customSubcategory?.includeInTotalWorkSeats &&
      wsBreakdownBySubcategory[CUSTOM_SUBCATEGORY]?.length > 0
    );
  }, [customSubcategory, wsBreakdownBySubcategory]);

  return {
    customSubcategory,
    hasSpacesNotIncludedInTotalSeats,
  };
};

export const useCardIcon = (cardType: ProgramSummaryCardType) => {
  const programSummaryCardIcons = useSelector(selectProgramSummaryCardIcons);

  return useMemo(() => {
    return programSummaryCardIcons.find(
      (programSummaryCardIcon) => programSummaryCardIcon.cardType === cardType
    );
  }, [programSummaryCardIcons, cardType]);
};
